module.exports = __webpack_public_path__ + "img/di_16_DebtPay.b5bfbc10.png";